import { isEmpty } from 'remeda'
import type { Image, ProductMedia } from '@velasca/types'
import { parseJSONSafe } from '@velasca/utils/parse-json-safe'

/**
 *
 * Sets `react-loaded` class on empty sections with min-height that prevent CLS,
 * after React is loaded they are not necessary anymore, so they needs to be hidden.
 *
 * @param sectionSelectors - Is an array of selectors of sections that should be hidden.
 */
export const hideSections = (sectionSelectors: string[]) => {
  sectionSelectors.forEach((sectionSelector) => {
    const nodes = document.querySelectorAll(sectionSelector)

    if (!isEmpty(nodes)) {
      nodes.forEach((collectionIntro) => {
        collectionIntro.classList.add('react-loaded')
      })
    }
  })
}

const transformToSliderImages = (productMedia: Image[]): ProductMedia => {
  const slides = productMedia?.map((image, i) => {
    return {
      ...image,
      // type: 'bullet',
      id: `${i}`,
    }
  })
  const thumbnails = productMedia?.map((_, i) => {
    return {
      type: 'bullet',
      id: `${i}`,
    } as const
  })

  return {
    slides: slides ?? [],
    // @ts-expect-error
    thumbnails: thumbnails ?? [],
  }
}

export const getCollectionShowcasePageData = () => {
  // General page options
  const pageGeneralOptionsEl = document.querySelector('#page-general-options')
  const pageGeneralOptionsJSON = pageGeneralOptionsEl?.innerHTML || '{}'

  // Visual top
  const visualTopEl = document.querySelector('#visual-top-video-json')
  const visualTopJSON = visualTopEl?.innerHTML || '{}'

  // Collection intro
  const collectionIntroEl = document.querySelector('#collection-intro')
  const collectionIntroJSON = collectionIntroEl?.innerHTML || '{}'
  const rawCollectionIntro = parseJSONSafe(collectionIntroJSON)

  const collectionIntro =
    collectionIntroJSON !== '{}'
      ? {
          ...rawCollectionIntro,
          mobileSliderImages: transformToSliderImages(
            rawCollectionIntro?.mobileSliderImages as Image[],
          ),
        }
      : null

  // Products and related products
  const productCompositions = []
  let counter = 1

  while (true) {
    // Product n
    const productEl = document.querySelector<HTMLElement>(
      `#collection-showcase-product-card-page-product-${counter}`,
    )

    // Checking if query selector is not null
    if (productEl) {
      const productJSON = productEl?.innerHTML || '{}'
      const relatedProductstEl = document.querySelector<HTMLElement>(
        `#collection-showcase-page-related-products-${counter}`,
      )
      const relatedProductsJSON = relatedProductstEl?.innerHTML || '[]'
      const rawRelatedProducts = parseJSONSafe(relatedProductsJSON)

      // Pushing product and related products to products array only if product is not empty
      if (productJSON !== '{}') {
        const rawProduct = parseJSONSafe(productJSON)

        productCompositions.push({
          product: {
            ...rawProduct,
            mobileSliderImages: transformToSliderImages(
              rawProduct?.mobileSliderImages as Image[],
            ),
          },
          relatedProducts: {
            ...rawRelatedProducts,
          },
        })
      }
      counter++
    } else {
      break
    }
  }

  const sliderEl = document.querySelector('#squared-video')
  const sliderJSON = sliderEl?.innerHTML || '{}'

  // Visual bottom images
  const visualBottomEl = document.querySelector('#visual-bottom-json')
  const visualBottomJSON = visualBottomEl?.innerHTML || '{}'

  return {
    pageGeneralOptions: parseJSONSafe(pageGeneralOptionsJSON),
    visualTopVideo: parseJSONSafe(visualTopJSON),
    collectionIntro,
    productCompositions,
    slider: parseJSONSafe(sliderJSON),
    visualBottom: parseJSONSafe(visualBottomJSON),
  }
}
